/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Helmet } from "react-helmet";
import "../../styles/SearchMap.css";
import { useParams } from 'react-router-dom';
import swal from 'sweetalert2';
import { getStoreData, returnToStore } from '../../Services/Events.services';
import kleenhub_logo from "../../Images/plain_logo.png";
import store_image from "../../Images/store_image.png";
import checkmark from "../../Images/checkmark.gif";
import celebration from "../../Images/celebration.gif";
import dump from "../../Images/dump.gif";
import { Button, IconButton } from '@mui/material';
import { QrReader } from 'react-qr-reader';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
const webSiteUrl = 'https://kleenhub.com';
const androidSettings = 'https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DAndroid';

export const BinReturn = () => {

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    React.useEffect(() => {
        document.title = 'kleen hub - Return';  
    }, []);

    const [flag, setFlag] = React.useState(true);
    const [flag2, setFlag2] = React.useState(true);
    const [flag3, setFlag3] = React.useState(false);
    const [flag4, setFlag4] = React.useState(true);
    const { id: storeId } = useParams();
    const [spinnerList, setSpinnerList] = React.useState(false);
    const [storeData, setStoreData] = React.useState(null);
    const [returnData, setReturnData] = React.useState(null);
    const [cameraPermission, setCameraPermission] = React.useState(null);
    React.useEffect(() => {
        const getStoreDetails = async () => {
            try {
                setSpinnerList(true);
                if (storeId) {
                    const response = await getStoreData(storeId);
                    if (response.status === 200) {
                        const data = await response?.data;
                        if (data) {
                            setStoreData(data);
                        }
                    } else {
                        swal.fire('Error', 'Store data not available', 'error');
                    }
                }
                setSpinnerList(false);
            } catch (err) {
                setSpinnerList(false)
                swal.fire('Error', err.response.data.message, 'error');
            }
        };
        if (storeData === null) {
            getStoreDetails();
        }
        // eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        if (!flag3 && flag4) {
            const interval = setInterval(() => {
                setFlag4(false);
            }, 1500);
            return () => clearInterval(interval);
        }
    }, [flag3, flag4]);

    React.useEffect(() => {
        navigator.permissions.query({ name: "camera" }).then(res => {
            if(res.state === "denied"){
                setCameraPermission(false)
            } else {
                setCameraPermission(true)
            }
            res.onchange = () => {
                if(res.state === "denied"){
                    setCameraPermission(false)
                } else {
                    setCameraPermission(true)
                }
            };
        });
    }, [cameraPermission]);

    const onButtonClick = () => {
        setFlag(!flag)
        setFlag2(true)
        // setFlag3(true)
        setFlag4(true)
    }

    const onButtonClick3 = () => {
        // setFlag3(!flag3)
        setFlag4(true)
    }

    const verifySuccess = () => {
        return (
            flag ? Page1() : Page2()
        )
    }

    const handleScan = async (text) => {
        try {
            setSpinnerList(true);
            if (storeId) {
                const items = text?.split('/');
                const productId = items[items.length - 1];
                const response = await returnToStore({
                    storeId: storeData.id,
                    productId,
                });
                if (response.status === 201) {
                    const data = await response?.data;
                    if (data) {
                        setReturnData(data);
                        setFlag(!flag)
                        setFlag2(!flag2)
                        // setFlag3(true)
                        setFlag4(true)
                    }
                } else {
                    swal.fire('Error', 'Something went wrong', 'error');
                }
            } else {
                swal.fire('Error', 'Store data not available', 'error');
            }
            setSpinnerList(false);
        } catch (err) {
            const items = text?.split('/');
            const productId = items[items.length - 1];
            setSpinnerList(false)
            const errorData = {
                title: 'Error',
                text: err.response.data.message,
                icon: 'error', 
            };
            if (err.response.data.message.includes('store cannot receive this type of packaging') ) {
                errorData.footer = `<a href=/status/${productId}>Click here </a> \b to see where you can return it.`;
            }
            swal.fire(errorData);
        }
    }

    const handleScanError = (err) => {
        console.error(err);
    }

    const isiOS = () => {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
          ].includes(navigator.platform);
    }

    const Page1 = () => {
        return (
            <div style={{ maxWidth: '480px', width: '100%', position: 'absolute',
            top: '0%', left: '50%', marginRight: '-50%', transform: 'translate(-50%, 0%)'}}>
                <a className='title' style={{ maxWidth: '480px', top: '20px' }} target={'_blank'} rel={'noreferrer'} href={webSiteUrl}>
                    <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }} src={kleenhub_logo}/>
                </a>
                <div className="img1" id="first-page">
                    <img alt="KleenHub Logo" style={{ maxHeight: '50vh', maxWidth: '480px' }} height={"100%"} width={"100%"} src={storeData.image || store_image}/>
                    <div className='div-text'>
                        <div id="oval_parent" className="multi-ellipse" style={{ top: '-40px', display: 'block' }}>
                            <div id="oval"></div>
                        </div>
                        <div className='rounded-div'>
                            <QrReader
                                videoStyle={{ width: '140px', height: '140px', objectFit: 'cover',
                                borderRadius: '20px', backgroundColor: '#ffffff' }}
                                containerStyle={{ width: '140px', height: '140px', objectFit: 'cover', border: '3px solid #FFFFFF',
                                filter: 'drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))', borderRadius: '20px', backgroundColor: '#ffffff' }}
                                delay={300}
                                onError={handleScanError}
                                constraints={{ facingMode: 'environment', aspectRatio: { exact: 2.5 } }}
                                onResult={(result, error) => {
                                    if (!!result) {
                                        handleScan(result?.text);
                                    }
                                }}
                            />
                            {
                                cameraPermission === false ?
                                    isiOS() ? 
                                    null
                                    :
                                    <p className='no-permission'>
                                        Please enable your camera. 
                                        <a style={{ color: 'black', textDecoration: 'underline' }} target={'_blank'} rel={'noreferrer'} href={androidSettings}><br/>How do I do it?</a>
                                    </p>
                                : null
                            }
                        </div>
                        <div>
                            <p className='scan-text-content' style={{ width:'140px', textAlign: 'right', right: '45%', marginTop: '-215px', lineHeight: '18px' }}>          
                                Scan the QR code on the packaging you wish to return.
                            {
                                isiOS() ?
                                <>
                                    <br/><br/>
                                    <a className='scan-text-content' style={{ width:'140px', textAlign: 'right', right: '15%', marginTop: '-5px', lineHeight: '18px', padding: '0px', textDecoration: 'underline' }} href={"javascript:window.location.href=window.location.href"}>Activate Camera</a>
                                </>
                                : null
                            }
                            </p>
                        </div>
                        <div className="vertical-center" style={{ display: 'block', width: '90%', marginTop: '10%' }}>
                            <p className='text-content-left' style={{ position: 'relative', marginTop: '-90px', textAlign: 'center', padding: '12px' }}>
                                Welcome to {storeData.name}
                            </p>
                            <Button variant="outlined"
                                style={{ backgroundColor: 'transparent', borderRadius: "50%", left: '33%', top: '-15px', letterSpacing: '0px', lineHeight: '0.9', width: "135px", height: "60px",
                                fontFamily: "Work Sans Italic", fontSize: "17px",
                                textTransform: "none", border: "2px solid #538103", color: '#538103' }}
                                disableRipple={true}
                                onClick={onButtonClick}
                                >
                                    what's all this?
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const Page2 = () => {
        return (
            flag2 ? Page2Default() : Page3()
        )
    }

    const Page3 = () => {
        return (
            flag3 ? Page3Default() : Page4()
        )
    }

    const Page4 = () => {
        return (
            flag4 ? Page4Default() : Page5()
        )
    }

    const Page2Default = () => {
        return (
            <div style={{ maxWidth: '480px', width: '100%', position: 'absolute',
            top: '0%', left: '50%', marginRight: '-50%', transform: 'translate(-50%, 0%)'}}>
                <div className='linearGradient'>
                    
                </div>
                <a className='title' style={{ maxWidth: '480px', top: '20px' }} target={'_blank'} rel={'noreferrer'} href={webSiteUrl}>
                    <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }} src={kleenhub_logo}/>
                </a>
                <div className="vertical-center" style={{ display: 'block', width: '100%', top: '260px', position: 'relative' }}>
                    <p className='text-content-left' style={{ position: 'relative', marginTop: '-90px', textAlign: 'center', padding: '0px' }}>
                        How it works
                    </p>
                    <p className='text-content-right' style={{ position: 'relative', textAlign: 'center', padding: '25px' }}>          
                        Welcome to the reuse revolution!<br/><br/>
                        {storeData.name} is a member of kleen hub's family, providing reusable packaging for customers to borrow at no cost.<br/><br/>
                        To borrow packaging, simply request it from the staff and tap your payment card on the device located at the counter. Borrowing packaging is free as long as it's returned on time.<br/><br/>
                        Speak with the staff and begin eliminating single-use!<br/><br/>
                        For additional information, please <a style={{ color: '#538103', textDecoration: 'underline' }} target={'_blank'} rel={'noreferrer'} href={webSiteUrl}>visit our website.</a>
                    </p>
                    <div className="vertical-left" style={{ transform: 'none', display: 'block' }} >
                        <IconButton aria-label="back" variant="outlined" color="success" onClick={onButtonClick}>
                            <ArrowBackIcon fontSize='large'/>
                        </IconButton>
                    </div>
                </div>
            </div>
        )
    }

    const Page3Default = () => {
        return (
            <div style={{ maxWidth: '480px', width: '100%', position: 'absolute',
            top: '0%', left: '50%', marginRight: '-50%', transform: 'translate(-50%, 0%)'}}>
                <div className='linearGradient'>
                    
                </div>
                <a className='title' style={{ maxWidth: '480px', top: '20px' }} target={'_blank'} rel={'noreferrer'} href={webSiteUrl}>
                    <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }} src={kleenhub_logo}/>
                </a>
                <img alt="dump here" className='rounded-image' height={"100%"} width={"100%"} src={dump}/>
                <div className="vertical-center" style={{ display: 'block', width: '100%', top: '100px', position: 'relative' }}>
                    <p className='text-content-left' style={{ position: 'relative', marginTop: '-135px', textAlign: 'center', padding: '00px 40px 0px 40px', top: '0px' }}>
                        Drop the packaging in the bin.
                    </p>
                    <Button variant="outlined"
                        style={{ position:'absolute', top: '23vh', backgroundColor: 'transparent', borderRadius: "50%", left: '33%', lineHeight: '1', width: "129px", height: "55px",
                        fontFamily: "Work Sans Italic", fontSize: "17px",
                        textTransform: "none", border: "2px solid #538103", color: '#538103' }}
                        disableRipple={true}
                        onClick={onButtonClick3}
                        >
                            next
                    </Button>
                </div>
            </div>
        )
    }

    const Page4Default = () => {
        return (
            <div>
                <div style={{ maxWidth: '480px', width: '100%', position: 'absolute',
                top: '0%', left: '50%', marginRight: '-50%', transform: 'translate(-50%, 0%)'}}>
                    <div className='linearGradient'>
                    </div>
                    <a className='title' style={{ maxWidth: '480px', top: '20px' }} target={'_blank'} rel={'noreferrer'} href={webSiteUrl}>
                        <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }} src={kleenhub_logo}/>
                    </a>
                </div>
                <img alt="checkmark" width={"50px"} style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, 0%)' }} src={checkmark}/>
            </div>
        )
    }

    const Page5 = () => {
        return (
            <div style={{ maxWidth: '480px', width: '100%', position: 'absolute',
            top: '0%', left: '50%', marginRight: '-50%', transform: 'translate(-50%, 0%)'}}>
                <div className='linearGradient'>
                    
                </div>
                <a className='title' style={{ maxWidth: '480px', top: '20px' }} target={'_blank'} rel={'noreferrer'} href={webSiteUrl}>
                    <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }} src={kleenhub_logo}/>
                </a>
                <img alt="celebration" height={"100%"} width={"100%"} src={celebration}/>
                <div className="vertical-center" style={{ display: 'block', width: '100%', top: '-150px', position: 'relative' }}>
                    <p className='text-content-left' style={{ position: 'relative', marginTop: '-90px', textAlign: 'center', padding: '0px 40px 0px 40px', top: '20px' }}>
                        Return <br/> registered.
                    </p>
                    {
                        (returnData && returnData.discountData &&
                            returnData.discountData.discountAllowed && returnData.discountData.discount > 0) ?
                        (
                        returnData.discountData.noOfDiscounts === 999999 ?
                            (
                                <>
                                    <div className='discount-ellipse' >
                                        <p className='discount-text'>Discount!</p>
                                    </div>
                                    <p className='text-content-right' style={{ position: 'relative', textAlign: 'center', padding: '0px 40px 0px 40px', top: '-25px' }}>
                                        Bacause this is one of your first {returnData.discountData.noOfDiscounts} returns, {storeData.name} wants to reward you with a {returnData.discountData.discount}% discount on a new purchase.
                                        <br /><br />Show this screen to the staff to claim it now!
                                    </p>
                                </>
                            )
                            :
                            (
                                <>
                                    <div className='discount-ellipse'>
                                        <p className='discount-text'>Discount!</p>
                                    </div>
                                    <p className='text-content-right' style={{ position: 'relative', textAlign: 'center', padding: '0px 40px 0px 40px', top: '-25px' }}>
                                        {storeData.name} wants to reward you with {returnData.discountData.discount}% discount on a new purchase.
                                        <br/><br/>Show this screen to the staff to claim it now!
                                    </p>
                                </>
                            )
                        )
                        :
                        null
                    }
                    {(returnData?.refundString) ?
                        <p className='text-content-right' style={{ position: 'relative', textAlign: 'center', padding: '0px', width: '100%', top: '-25px' }}>
                            Your {returnData?.refundString || '25 DKK'} refund is on the way.
                        </p>
                        : 
                        null
                    }
                    <Button variant="outlined"
                        style={{ backgroundColor: 'transparent', borderRadius: "50%", left: '36%', position:'absolute', top: '22vh', lineHeight: '1', width: "129px", height: "55px",
                        fontFamily: "Work Sans Italic", fontSize: "17px",
                        transform: 'translate(0%, 250%)',
                        textTransform: "none", border: "2px solid #538103", color: '#538103' }}
                        disableRipple={true}
                        onClick={onButtonClick}
                        >
                            again
                    </Button>
                </div>
            </div>
        )
    }

    return (
        <div>
            <Helmet>
                <title>kleenhub</title>
            </Helmet>
            <div className='upcoming_leagues_background_img'>
                <div className='leagues_details'>
                </div>
            </div>
            {
                (!spinnerList && storeData) ? verifySuccess() : null
            }
        </div>
    )
}
